
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form16";
const form16State = namespace("Form16");

import Form16ProcessHeader from "@/components/process/Form16/components/Form16ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { form16DataInfoType, form16StatusInfoType } from '@/types/Information/Form16';
import { packageInfoType } from '@/types/Information';

@Component({
    components:{
        Form16ProcessHeader,
        Spinner
    }
})
export default class SubmitForm16 extends Vue {

    @form16State.State
    public currentOfferToSettleCostsId: string;

    @form16State.State
    public form16Info: form16DataInfoType;

    stepsCompleted = {} as form16StatusInfoType;  
    mountedData = false;   
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg="";

    mounted() {
        this.mountedData = false;
        this.submitting = false; 
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public submit() {

        this.submitting = true;
        this.errorMsg =""

        const url = "/form16/efiling/"+this.currentOfferToSettleCostsId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        const body = {
            document_type: "AOSC"
        }

        this.$http.post(url, body, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }   

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
